import PieChartIcon from '@material-ui/icons/PieChart';
import GavelTwoToneIcon from '@material-ui/icons/GavelTwoTone';
import InsertDriveFile from '@material-ui/icons/InsertDriveFile';
import SailingTwoToneIcon from '@material-ui/icons/SailingTwoTone';
import SettingsTwoToneIcon from '@material-ui/icons/SettingsTwoTone';
import AssessmentTwoToneIcon from '@material-ui/icons/AssessmentTwoTone';
import AccountTreeTwoToneIcon from '@material-ui/icons/AccountTreeTwoTone';
import RemoveRedEyeTwoToneIcon from '@material-ui/icons/RemoveRedEyeTwoTone';
import PictureAsPdfTwoToneIcon from '@material-ui/icons/PictureAsPdfTwoTone';
import MonetizationOnTwoToneIcon from '@material-ui/icons/MonetizationOnTwoTone';

// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// components
import SvgIconStyle from '../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle src={`/static/icons/navbar/${name}.svg`} sx={{ width: '100%', height: '100%' }} />
);

const getIcon2 = () => <InsertDriveFile />;

const ICONS = {
  user: getIcon('ic_user'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  InsertDriveFile: getIcon2(),
  setting: <SettingsTwoToneIcon />,
  removeRedEye: <RemoveRedEyeTwoToneIcon />,
  pic: <PictureAsPdfTwoToneIcon />,
  payment: <MonetizationOnTwoToneIcon />,
  workFlow: <AccountTreeTwoToneIcon />,
  control: <GavelTwoToneIcon />,
  report: <AssessmentTwoToneIcon />,
  export: <SailingTwoToneIcon />,
  pieChart: <PieChartIcon />
};

const sidebarConfig = [
  {
    items: [
      {
        title: 'Master',
        path: PATH_DASHBOARD.master.root,
        icon: ICONS.setting,
        children: [
          {
            title: 'Configuration',
            path: PATH_DASHBOARD.master.configuration,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Cutoff Document',
            path: PATH_DASHBOARD.master.cutoffDocument,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Customer',
            path: PATH_DASHBOARD.master.customerBehavior,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Risk Category',
            path: PATH_DASHBOARD.master.riskCategory,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Bill Collector',
            path: PATH_DASHBOARD.master.creditRepGroup,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Payment Term',
            path: PATH_DASHBOARD.master.custCredGroup,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Customers Bank',
            path: PATH_DASHBOARD.master.customerBank,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Payment Bank',
            path: PATH_DASHBOARD.master.paymentBank,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Incoming GL',
            path: PATH_DASHBOARD.master.incommingGL,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Credit Team',
            path: PATH_DASHBOARD.master.creditTeam,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Credit Team Mapping',
            path: PATH_DASHBOARD.master.creditMapping,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Trade Type',
            path: PATH_DASHBOARD.master.tradeType,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Bill Method',
            path: PATH_DASHBOARD.master.billMethod,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Payment Type',
            path: PATH_DASHBOARD.master.paymentType,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'SCG Holiday',
            path: PATH_DASHBOARD.master.scgHoliday,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Bank Holiday',
            path: PATH_DASHBOARD.master.bankHoliday,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Main Sales Employee',
            path: PATH_DASHBOARD.master.mainSalesEmp,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'E-mail Group',
            path: PATH_DASHBOARD.master.emailGroup,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Config E-mail',
            path: PATH_DASHBOARD.master.configEmail,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Main Sales Group Sales Office',
            path: PATH_DASHBOARD.master.mainSalesGroupSalesOffice,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Select-In / Select-Out',
            path: PATH_DASHBOARD.master.selectInSelectOut,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Insurance Company',
            path: PATH_DASHBOARD.master.insuranceCompany,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Snap Credit Master',
            path: PATH_DASHBOARD.master.snapCreditMaster,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Users',
            path: PATH_DASHBOARD.master.users,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Role',
            path: PATH_DASHBOARD.master.role,
            icon: ICONS.InsertDriveFile
          }
        ]
      },
      {
        title: 'Invoice Management',
        path: PATH_DASHBOARD.invoiceManagement.root,
        icon: ICONS.removeRedEye,
        children: [
          {
            title: 'Invoice & DP for Logistic WH',
            path: PATH_DASHBOARD.invoiceManagement.bill,
            icon: ICONS.InsertDriveFile
          },
          { title: 'Following PO', path: PATH_DASHBOARD.invoiceManagement.po, icon: ICONS.InsertDriveFile },
          {
            title: 'Following Invoice',
            path: PATH_DASHBOARD.invoiceManagement.following,
            icon: ICONS.InsertDriveFile
          },
          // { title: 'Outsource', path: PATH_DASHBOARD.invoiceManagement.outsource, icon: ICONS.InsertDriveFile },
          { title: 'Outsource', path: PATH_DASHBOARD.invoiceManagement.newOutsource, icon: ICONS.InsertDriveFile },
          {
            title: 'Calling & Daily',
            path: PATH_DASHBOARD.invoiceManagement.callingDaily,
            icon: ICONS.InsertDriveFile
          },
          { title: 'BU Messenger', path: PATH_DASHBOARD.invoiceManagement.buMessenger, icon: ICONS.InsertDriveFile },
          { title: 'E-mail', path: PATH_DASHBOARD.invoiceManagement.email, icon: ICONS.InsertDriveFile },
          { title: 'EMS', path: PATH_DASHBOARD.invoiceManagement.ems, icon: ICONS.InsertDriveFile },
          {
            title: 'Customer System',
            path: PATH_DASHBOARD.invoiceManagement.customerSystem,
            icon: ICONS.InsertDriveFile
          }
        ]
      },
      {
        title: 'Document Management',
        path: PATH_DASHBOARD.documentManagement.root,
        icon: ICONS.pic,
        children: [
          {
            title: 'Bill Presentment & Invoice',
            translateKey: 'menu.documentManagement.bill',
            path: PATH_DASHBOARD.documentManagement.documentInvoice,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Receipt',
            translateKey: 'menu.documentManagement.receipt',
            path: PATH_DASHBOARD.documentManagement.billingReceipt,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Bill Of Exchange',
            translateKey: 'menu.documentManagement.be',
            path: PATH_DASHBOARD.documentManagement.ticketBE,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Domestic Letter Of Credit',
            translateKey: 'menu.documentManagement.dlc',
            path: PATH_DASHBOARD.documentManagement.ticketDLC,
            icon: ICONS.InsertDriveFile
          }
        ]
      },
      {
        title: 'Payment Management',
        path: PATH_DASHBOARD.paymentManagement.root,
        icon: ICONS.payment,
        children: [
          {
            title: 'Following Payment',
            path: PATH_DASHBOARD.paymentManagement.followingPayment,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Incoming Payment',
            path: PATH_DASHBOARD.paymentManagement.incomingPayment,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Search Problem',
            path: PATH_DASHBOARD.paymentManagement.searchProblem,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'G/L Statement',
            path: PATH_DASHBOARD.paymentManagement.glStatemant,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Cheque Return',
            path: PATH_DASHBOARD.paymentManagement.chequeReturn,
            icon: ICONS.InsertDriveFile
          }
        ]
      },
      {
        title: 'Work Flow',
        path: PATH_DASHBOARD.workFlow.root,
        icon: ICONS.workFlow,
        children: [
          {
            title: 'Late Charge',
            path: PATH_DASHBOARD.workFlow.lateCharge,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Postpone Cheque',
            path: PATH_DASHBOARD.workFlow.postponeCheque,
            icon: ICONS.InsertDriveFile
          },
          {
            title: `Request Cancel Credit Block`,
            path: PATH_DASHBOARD.workFlow.suspend,
            icon: ICONS.InsertDriveFile
          },
          {
            title: `Questionnaires`,
            path: PATH_DASHBOARD.workFlow.questionnaires,
            icon: ICONS.InsertDriveFile
          }
        ]
      },
      {
        title: 'Control Management',
        path: PATH_DASHBOARD.controlManagement.root,
        icon: ICONS.control,
        children: [
          {
            title: 'Highlight Overdue',
            path: PATH_DASHBOARD.controlManagement.highlightOverdue,
            icon: ICONS.InsertDriveFile
          }
        ]
      },
      {
        title: 'Risk Management',
        path: PATH_DASHBOARD.riskManagement.root,
        icon: ICONS.pieChart,
        children: [
          {
            title: 'Insurance',
            path: PATH_DASHBOARD.riskManagement.insurance,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Debenture',
            path: PATH_DASHBOARD.riskManagement.debenture,
            icon: ICONS.InsertDriveFile
          }
        ]
      },
      {
        title: 'Report',
        path: PATH_DASHBOARD.report.root,
        icon: ICONS.report,
        children: [
          {
            title: 'Plan Cash In Flow',
            path: PATH_DASHBOARD.report.planCashInFlow,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Overdue Report',
            path: PATH_DASHBOARD.report.overdueReport,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Late Charge Report',
            path: PATH_DASHBOARD.report.monthlyReport,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Cheque Return Report',
            path: PATH_DASHBOARD.report.chequeReturnReport,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Sales Volume by Credit Term',
            path: PATH_DASHBOARD.report.salesVolumeByCreditTerm,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'KPI Overdue',
            path: PATH_DASHBOARD.report.kpiOverdue,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'SCGP Management Committee',
            path: PATH_DASHBOARD.report.committee,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Upload Data',
            path: PATH_DASHBOARD.report.nonSap,
            icon: ICONS.InsertDriveFile
          }
        ]
      },
      {
        title: 'Export Payment',
        path: PATH_DASHBOARD.exportPayment.root,
        icon: ICONS.export,
        children: [
          {
            title: 'Following Payment',
            title2: 'Following Payment Export',
            path: PATH_DASHBOARD.exportPayment.followingPaymentExport,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Incoming Payment',
            title2: 'Incoming Payment Export',
            path: PATH_DASHBOARD.exportPayment.incomingPaymentExport,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Search Problem',
            title2: 'Search Problem Export',
            path: PATH_DASHBOARD.exportPayment.searchProblemExport,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Overdue Report',
            title2: 'Overdue Report Export',
            path: PATH_DASHBOARD.exportPayment.overdueReportExport,
            icon: ICONS.InsertDriveFile
          },
          {
            title: 'Credit Advice',
            path: PATH_DASHBOARD.exportPayment.creditAdvice,
            icon: ICONS.InsertDriveFile
          }
        ]
      }
    ]
  }
];

export default sidebarConfig;
